<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="dedic1"><a id="page_iv">For Sofia, who first sang the song—</a></p><a id="page_iv">
<p class="dedic">For Nicky, who sings it too.</p>
<p class="dedic">Love,</p>
<p class="dedi">P. M.</p>
</a></div><a id="page_iv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?21fba47c